/**
 * Minimal CSV reading and writing (RFC 4180): quoted fields, doubled quotes inside them, commas and
 * line breaks inside quotes, and both CRLF and LF line endings. Blank lines are skipped.
 */

/** Rows of fields. A leading byte-order mark (Excel adds one) is ignored. */
export function parseCsv(text: string): string[][] {
  const input = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text
  const rows: string[][] = []
  let row: string[] = []
  let field = ''
  let quoted = false

  const endRow = () => {
    row.push(field)
    if (row.length > 1 || row[0].trim() !== '') rows.push(row)
    row = []
    field = ''
  }

  for (let i = 0; i < input.length; i++) {
    const ch = input[i]
    if (quoted) {
      if (ch === '"') {
        if (input[i + 1] === '"') {
          field += '"'
          i++
        } else {
          quoted = false
        }
      } else {
        field += ch
      }
    } else if (ch === '"') {
      quoted = true
    } else if (ch === ',') {
      row.push(field)
      field = ''
    } else if (ch === '\n' || ch === '\r') {
      if (ch === '\r' && input[i + 1] === '\n') i++
      endRow()
    } else {
      field += ch
    }
  }
  if (field !== '' || row.length > 0) endRow()
  return rows
}

function quote(value: string): string {
  return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value
}

/** CSV text for `rows`, CRLF line endings, fields quoted only when they need it. */
export function toCsv(rows: string[][]): string {
  return rows.map((r) => r.map(quote).join(',')).join('\r\n') + '\r\n'
}
